import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { CheckCircle2, Home } from 'lucide-react';
import { fadeInUp, staggerContainer } from '@/lib/animations';

export default function LandingThankYouPage() {
  return (
    <div data-testid="landing-thank-you-page" className="min-h-screen bg-brand-black flex items-center">
      <Helmet>
        <title>Thank You — custum.ai</title>
        <meta name="description" content="Thanks for getting in touch. We'll be in touch within 24 hours." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-24 text-center">
        <motion.div initial="hidden" animate="visible" variants={staggerContainer}>
          <motion.div variants={fadeInUp} className="w-20 h-20 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-8">
            <CheckCircle2 size={40} className="text-green-400" />
          </motion.div>
          <motion.h1 variants={fadeInUp} className="text-4xl sm:text-6xl font-extrabold text-brand-white tracking-tight mb-6">
            Message <span className="text-brand-blue">Sent!</span>
          </motion.h1>
          <motion.p variants={fadeInUp} className="text-base text-brand-muted leading-relaxed mb-10 max-w-md mx-auto">
            Thanks for getting in touch. We&apos;ll be in touch within 24 hours.
          </motion.p>
          <motion.div variants={fadeInUp}>
            <Link
              to="/"
              data-testid="thank-you-home-link"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-blue text-white font-semibold transition-all duration-300 shadow-[0_0_20px_rgba(var(--c-purple-rgb),0.3)] hover:shadow-[0_0_40px_rgba(var(--c-purple-rgb),0.6)] hover:bg-brand-blue-light"
            >
              <Home size={18} /> Back to Home
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
